import { doFetch } from './fetch.js';

const MSG_SAVE_ERROR = 'Favorit konnte nicht gespeichert werden.';
const MSG_REMOVE_ERROR = 'Favorit konnte nicht entfernt werden.';

/**
 * Wishlist toggle for card_product component.
 *
 * Toggles the favorite state by calling the existing shopController endpoints
 * (saveFavorite / delvormerkung). Updates the heart icon without a full page reload.
 */
document.addEventListener('click', function (e) {
  const button = e.target.closest('.js_card_product__wishlist');
  if (!button) {
    return;
  }

  e.preventDefault();
  e.stopPropagation();

  const articleTypeId = button.dataset.articleTypeId;
  if (!articleTypeId) {
    return;
  }

  const isActive = button.querySelector('.card_product__wishlist_icon--active') !== null;

  // Toggle UI immediately for responsiveness
  setWishlistState(button, !isActive);

  if (isActive) {
    removeWishlist(button, articleTypeId);
  } else {
    addWishlist(button, articleTypeId);
  }
});

function addWishlist(button, articleTypeId) {
  const data = new URLSearchParams({
    article_type_id: articleTypeId,
    return_html: '0',
  });

  doFetch(
    '/shopController.php?objective=saveFavorite',
    { method: 'POST', body: data },
    (res) => {
      if (!res.success) {
        setWishlistState(button, false);
        showFeedback(button, res.error || MSG_SAVE_ERROR);
      }
    },
    () => {
      setWishlistState(button, false);
      showFeedback(button, MSG_SAVE_ERROR);
    },
  );
}

async function removeWishlist(button, articleTypeId) {
  try {
    // ok: quality class (0 = any), mwst: VAT flag — required by the popupvormerkung endpoint
    const lookupData = new URLSearchParams({ atid: articleTypeId, ok: 0, mwst: 0 });

    const lookupRes = await new Promise((resolve, reject) => {
      doFetch('/shopController.php?objective=popupvormerkung', { method: 'POST', body: lookupData }, resolve, reject);
    });

    if (!lookupRes.id) {
      return;
    }

    const deleteData = new URLSearchParams({ id: lookupRes.id });
    const deleteRes = await new Promise((resolve, reject) => {
      doFetch('/shopController.php?objective=delvormerkung', { method: 'POST', body: deleteData }, resolve, reject);
    });

    if (!deleteRes.success) {
      setWishlistState(button, true);
      showFeedback(button, MSG_REMOVE_ERROR);
    }
  } catch {
    setWishlistState(button, true);
    showFeedback(button, MSG_REMOVE_ERROR);
  }
}

function setWishlistState(button, active) {
  const icon = button.querySelector('.card_product__wishlist_icon');
  if (!icon) {
    return;
  }

  if (active) {
    icon.classList.add('card_product__wishlist_icon--active', 'lucide_icon--fill');
  } else {
    icon.classList.remove('card_product__wishlist_icon--active', 'lucide_icon--fill');
  }
}

/**
 * Shows a temporary feedback tooltip near the wishlist button.
 * Removed automatically when the CSS fade animation ends.
 */
function showFeedback(button, message) {
  const card = button.closest('.card_product');
  if (!card) {
    return;
  }

  card.querySelector('.card_product__feedback')?.remove();

  const feedback = document.createElement('div');
  feedback.className = 'card_product__feedback';
  feedback.textContent = message;
  card.appendChild(feedback);

  feedback.addEventListener('animationend', () => feedback.remove());
}
